/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import Header from './Header';
import Answer from './Answer';
import { useQuestion } from '../../hooks';
import styles from './question.module.css';

type props = {
  isMobile?: boolean;
  isVerticalLayout?: boolean;
};

export const Question = ({ isMobile, isVerticalLayout }: props) => {
  const [heightZero, setHeightZero] = useState<boolean>(false);
  const [heightZeroTimeOut, setHeightZeroTimeOut] =
    useState<NodeJS.Timeout | null>(null);
  const isMobileHorizontal = isMobile && !isVerticalLayout;
  const isMobileVertical = isMobile && isVerticalLayout;
  const {
    currentQuestion,
    selectedAnswersIndices,
    handlePressAnswer,
    currentTimeSeconds,
    dataResults,
    hideQuestion,
    setHideQuestion,
  } = useQuestion();

  useEffect(() => {
    heightZeroTimeOut && clearTimeout(heightZeroTimeOut);
    const timeOut = setTimeout(
      () => {
        setHeightZero(hideQuestion);
      },
      hideQuestion ? 500 : 0,
    );
    setHeightZeroTimeOut(timeOut);
  }, [hideQuestion]);

  return (
    <div
      className={clsx(
        styles.questionWrapper,
        isMobileHorizontal && styles.questionWrapperMobileHorizontal,
        isMobileVertical && styles.questionContentMobileVertical,
        (hideQuestion || !currentQuestion) && styles.questionWrapperTransparent,
        (heightZero || !currentQuestion) && styles.questionWrapperHeightZero,
      )}
    >
      <div
        className={clsx(
          styles.questionContent,
          isMobileHorizontal && styles.questionContentMobileHorizontal,
        )}
      >
        <Header
          isMobile={isMobile}
          question={currentQuestion?.question}
          currentTimeSeconds={currentTimeSeconds}
          setHideQuestion={setHideQuestion}
        />
        {
          //Answers
          currentQuestion?.answers?.map((answer, index) => {
            return (
              <Answer
                key={index}
                selected={selectedAnswersIndices.includes(index)}
                atLeastOneSelected={selectedAnswersIndices.length > 0}
                data={answer}
                index={index}
                onPress={handlePressAnswer}
                result={dataResults !== null ? dataResults[index].votes : null}
                totalVotes={
                  dataResults !== null
                    ? dataResults.reduce((sum, answer) => sum + answer.votes, 0)
                    : 0
                }
              />
            );
          })
        }
      </div>
    </div>
  );
};
